import { render, staticRenderFns } from "./PatientVerificationCreate.vue?vue&type=template&id=73c2f601&scoped=true"
import script from "./PatientVerificationCreate.vue?vue&type=script&lang=js"
export * from "./PatientVerificationCreate.vue?vue&type=script&lang=js"
import style0 from "./PatientVerificationCreate.vue?vue&type=style&index=0&id=73c2f601&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c2f601",
  null
  
)

export default component.exports